import React from 'react';
import { Table } from 'antd';
import PropTypes from 'prop-types';

export default function BoardCardABWorkReportingTable({
  dataSource,
  columns,
  selectedEntity,
  setSelectedEntity,
  onRow,
  rowSelection = {},
}) {
  return (
    <Table
      dataSource={dataSource}
      columns={columns}
      rowKey="id"
      size="small"
      pagination={false}
      onRow={onRow}
      rowSelection={{
        selectedRowKeys: selectedEntity ? [selectedEntity.id] : [],
        onSelect: (selectedRow, selected) => {
          if (selected && selectedRow) {
            setSelectedEntity(selectedRow);
          } else {
            setSelectedEntity(null);
          }
        },
        getCheckboxProps: () => ({
          disabled: false,
          className: 'ontraccr-checkbox',
        }),
        hideSelectAll: true,
        ...rowSelection,
      }}
      onHeaderRow={() => ({
        className: 'ontraccr-table-header',
      })}
      tableLayout="auto"
    />
  );
}

BoardCardABWorkReportingTable.propTypes = {
  dataSource: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  selectedEntity: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  setSelectedEntity: PropTypes.func.isRequired,
  onRow: PropTypes.func.isRequired,
  rowSelection: PropTypes.shape({
    selectedRowKeys: PropTypes.array,
    onChange: PropTypes.func,
    onSelect: PropTypes.func,
    getCheckboxProps: PropTypes.func,
    hideSelectAll: PropTypes.bool,
  }),
};

BoardCardABWorkReportingTable.defaultProps = {
  selectedEntity: null,
  rowSelection: {},
};
